import { Pipe, PipeTransform, inject } from '@angular/core';
import { DomSanitizer, SafeHtml } from '@angular/platform-browser';
import { StringHelper } from '@core/helpers/string.helper';

@Pipe({
  name: 'ifNull',
  standalone: false
})
export class IfNullPipe implements PipeTransform {
  private sanitizer = inject(DomSanitizer);

  transform(
    value: string | number,
    defaultValue: string = '<span class="text-smg-darkGray">-</span>'
  ): string | number | SafeHtml {
    return StringHelper.isNullOrEmpty(value) ? this.sanitizer.bypassSecurityTrustHtml(defaultValue) : value;
  }
}
